<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <InfractionsTypesList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import InfractionsTypesList from "@/components/settings/frota/infractions-types/InfractionTypeList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "InfractionsTypes",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    InfractionsTypesList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addinfractiontype" });
    },
  },
};
</script>
